import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

export const useUiStore = defineStore('ui', () => {
  const rt = useRouter()
  const fullscreen = ref(false)
  const blockScreen = ref(false) // full screen spinner

  rt.afterEach(to => {
    if (to.name != 'orders.item' && fullscreen.value) {
      fullscreen.value = false
    }
  })

  return { fullscreen, blockScreen }
})
